import { CalendarAppointment, PatientFlagEntity } from '@xmedical/core';

/**
 * Returns a new appointments array with the given patient's flag set replaced
 * with the flags resolved from `flagIds`. Unknown IDs (not in `flagLookup`)
 * are dropped. When no appointment on display belongs to `patientId`, the
 * original array reference is returned so signal consumers can short-circuit.
 */
export function patchFlagsForPatient(
  appointments: CalendarAppointment[],
  patientId: number,
  flagIds: number[],
  flagLookup: Map<number, PatientFlagEntity>
): CalendarAppointment[] {
  if (!appointments.some(a => a.patient?.id === patientId)) return appointments;
  const newFlags = flagIds
    .map(id => flagLookup.get(id))
    .filter((f): f is PatientFlagEntity => f !== undefined);
  return appointments.map(appointment => {
    if (appointment.patient?.id !== patientId) return appointment;
    return {
      ...appointment,
      patient: { ...appointment.patient, flags: newFlags }
    };
  });
}
